import styled from "styled-components";

export const StyleWrapper = styled.div`
.sku-dropdown-opulent {
    position: relative;
    .css-19bb58m {
    position: absolute;
}
.css-1nmdiq5-menu {
    margin: 0;
    padding: 12px;
    margin-top: 4px;
    border-radius: 9px;
}
}
 div.card-item-wrapper {
    display: flex;
    align-items: flex-start;
    grid-gap: 4px;
    padding-bottom: 8px;
    border-bottom: 1px solid #DADADA;
    &:not(:last-child){
    margin-bottom: 8px;
    }
    &.value-ref-wrapper{
      border:none;
      padding-bottom: 0;
      margin-bottom: 0;
    }
    img {
    width: 36px;
    min-width: 36px;
    height: 36px;
    object-fit: contain;
}
.card-item-content {
    display: flex;
    flex-direction: column;
    grid-row-gap: 4px;
    & > p {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #535E63;
    margin: 0;
    width: 300px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
    .card-item-details {
    display: flex;
    align-items: center;
    grid-gap: 6px;
    p {
      margin: 0;
      padding: 2px;
      gap: 15px;
      border-radius: 4px;
      background: #576D80;
      font-size: 10px;
      font-weight: 400;
      line-height: 12px;
      text-align: left;
      color: #fff;
    }
}
}
}

`
